import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

const SkillsView = (props) => {
  const {onDelete, onEdit, skill} = props;

  if (!skill) {
    return (
      <Box
        sx={{
          width: '100%',
          p: '40px',
          boxSizing: 'border-box',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: '#A8A49E',
            lineHeight: '150%',
          }}
        >
          <Translate expression='skills.skills.View.Empty' />
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        p: '40px',
        boxSizing: 'border-box',
        backgroundColor: '#FFFFFF',
        overflowY: 'auto',
      }}
    >
      <Stack
        sx={{
          gap: '10px',
        }}
      >
        <Stack
          direction='row'
          alignItems='flex-start'
          justifyContent='space-between'
          sx={{
            gap: '24px',
            flexWrap: 'wrap',
          }}
        >
          <Stack
            sx={{
              gap: '12px',
            }}
          >
            <Stack
              direction='row'
              alignItems='center'
              sx={{
                gap: '8px',
                flexWrap: 'wrap',
              }}
            >
              <Typography
                sx={{
                  fontWeight: 400,
                  fontStyle: 'Regular',
                  fontSize: '22px',
                  color: '#1A1916',
                  lineHeight: '100%',
                }}
              >
                /{skill.name}
              </Typography>
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  px: '8px',
                  py: '4px',
                  borderRadius: '4px',
                  border: '1px solid #B8D3FF',
                  backgroundColor: '#EFF6FF',
                }}
              >
                <Typography
                  sx={{
                    fontSize: '11px',
                    fontWeight: 400,
                    color: '#2B63D9',
                    lineHeight: '100%',
                  }}
                >
                  {skill.outputType}
                </Typography>
              </Box>
            </Stack>
            <Typography
              sx={{
                fontWeight: 400,
                fontStyle: 'Regular',
                fontSize: '14px',
                color: '#A8A49E',
                lineHeight: '100%',
              }}
            >
              {skill.groupName}
            </Typography>
          </Stack>
          <Stack
            direction='row'
            sx={{
              gap: '8px',
            }}
          >
            <Button
              onClick={onEdit}
              disableElevation
              sx={{
                'minWidth': '0',
                'borderRadius': '7px',
                'px': '12px',
                'py': '8px',
                'fontWeight': 500,
                'fontStyle': 'Medium',
                'fontSize': '12px',
                'lineHeight': '100%',
                'textTransform': 'none',
                'color': '#FFFFFF',
                'backgroundColor': '#DA7955',
                '&:hover': {
                  backgroundColor: '#DA7955',
                  boxShadow: 'none',
                },
              }}
            >
              <Translate expression='skills.skills.View.Edit' />
            </Button>
            <Button
              onClick={onDelete}
              variant='outlined'
              disableElevation
              sx={{
                'minWidth': '0',
                'borderRadius': '7px',
                'px': '12px',
                'py': '8px',
                'fontWeight': 500,
                'fontStyle': 'Medium',
                'fontSize': '12px',
                'lineHeight': '100%',
                'textTransform': 'none',
                'color': '#8E8A84',
                'borderColor': '#E8E4DE',
                'backgroundColor': '#FFFFFF',
                '&:hover': {
                  backgroundColor: '#FFFFFF',
                  borderColor: '#E8E4DE',
                  boxShadow: 'none',
                },
              }}
            >
              <Translate expression='skills.skills.View.Delete' />
            </Button>
          </Stack>
        </Stack>
        <Box
          sx={{
            border: '1px solid',
            borderColor: '#E8E4DE',
            borderRadius: '12px',
            px: '14px',
            py: '12px',
            backgroundColor: '#FBFBFB',
          }}
        >
          <Stack
            sx={{
              gap: '10px',
            }}
          >
            <Typography
              sx={{
                fontSize: '11px',
                fontWeight: 600,
                color: '#A8A49E',
                lineHeight: '100%',
                textTransform: 'uppercase',
              }}
            >
              <Translate expression='skills.skills.View.Prompt' />
            </Typography>
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 400,
                color: '#1A1916',
                lineHeight: '150%',
              }}
            >
              {skill.prompt}
            </Typography>
            <Box sx={{borderBottom: '1px solid #E8E4DE'}}></Box>
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 400,
                color: '#6B6760',
                lineHeight: '150%',
              }}
            >
              <Translate expression='skills.skills.View.InvokeWithPrefix' />
              {' '}
              <Box component='span' sx={{color: '#2B63D9'}}>
                /{skill.name}
              </Box>
              {' '}
              <Translate expression='skills.skills.View.InvokeWithSuffix' />
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

SkillsView.propTypes = {
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  skill: PropTypes.shape({
    groupName: PropTypes.string,
    name: PropTypes.string,
    outputType: PropTypes.string,
    prompt: PropTypes.string,
  }),
};

export default React.memo(SkillsView);
